import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { useDeviceType, useMap } from '../../../hooks';

function MapToggleButton({ enableMap }) {
  const { isMobile } = useDeviceType();
  const { t } = useTranslation('dealers');
  const { setMapEnabled, mapVisible, setMapVisible } = useMap();
  const buttonRef = useRef(null);
  const mapId = 'dealer-map-popover';

  function showAndEnableMobileMap() {
    if (isMobile && mapVisible) {
      setMapVisible(false);
      return;
    }

    setMapVisible(true);

    if (enableMap) {
      setMapEnabled(true);
    }
  }

  // Move focus to toggle button/close map button when map visibility changes
  useEffect(() => {
    if (isMobile) {
      if (!mapVisible && document.activeElement.closest('#' + mapId)) {
        buttonRef.current.focus();
      }
      else if (mapVisible && document.activeElement === buttonRef.current) {
        document.querySelector(`[data-close-map="${mapId}"]`)?.focus();
      }
    }
  }, [mapVisible, isMobile]);

  return (
    <button
      ref={buttonRef}
      aria-expanded={mapVisible ? 'true' : 'false'}
      aria-controls={mapId}
      onClick={showAndEnableMobileMap}
      className="button button--primary chevron-left map-toggle-button"
    >
      {t('Show map')}
    </button>
  );
}

MapToggleButton.propTypes = {
  enableMap: PropTypes.bool,
};

export default MapToggleButton;
